module.exports = __webpack_public_path__ + "assets/img/li_icon.5052bad8.svg";